export default {
  pathPrefix: '/',
  siteTitle: 'Drew\'s Workbench', // Navigation and Site Title
  siteTitleAlt: 'Drew\'s Workbench', // Alternative Site title for SEO
  siteUrl: 'https://blog.xiuz.hu', // Domain of your site. No trailing slash!
  siteLanguage: 'en', // Language Tag on <html> element
  siteBanner: '/assets/banner.jpg', // Your image for og:image tag. You can find it in the /static folder
  defaultBg: '/assets/bg.png', // default post background header
  favicon: 'src/favicon.png', // Your image for favicons. You can find it in the /src folder
  siteDescription: 'My Blog', // Your site description
  author: 'Drew Xiu', // Author for schemaORGJSONLD
  siteLogo: '/assets/logo.jpg', // Image for schemaORGJSONLD

  // siteFBAppID: '123456789', // Facebook App ID - Optional
  userTwitter: '@drew_xiu', // Twitter Username - Optional
  ogSiteName: 'Drew.Xiu', // Facebook Site Name - Optional
  ogLanguage: 'en_US', // Facebook Language

  // Manifest and Progress color
  // See: https://developers.google.com/web/fundamentals/web-app-manifest/
  themeColor: '#3498DB',
  backgroundColor: '#2b2e3c',

  // Settings for typography.ts
  headerFontFamily: 'Bitter',
  bodyFontFamily: 'Open Sans',
  baseFontSize: '18px',

  // Social media
  siteFBAppID: '',

  GA_ID: 'UA-135755854-1',
  Google_Tag_Manager_ID: 'GTM-PHXXCX7',
  POST_PER_PAGE: 6,

  // tslint:disable-next-line:max-line-length
  aboutMe: 'A untalented gamer / kinda-okay web developer / lousy full-stack engineer / kick-ass modeler (aircraft only) / amateur drummer / safety-first sk8boi / dad',
}
